import React, { use, useEffect, useState } from 'react'
import { HorizontalLayout, VerticalLayout, VerticalPageLayout } from "../components/layout"
import { TitleAtom } from "../atoms/titleAtom"
import { ButtonGroup, IconButton, } from "../atoms/buttons"
import { TasksPage } from "../components/tasks/TaskPage";
import { TemplatePage } from "../components/tasks/Templates";
import { Modal, ModalBody, ModalTitle } from "../components/modal";
import { StandardComp } from "../atoms/standardComp";
import { id, vi } from "date-fns/locale";
import { TextAtom } from "../atoms/TextAtom";

export function Tasks({pageSwap}) {
    const [selectedPage, setSelectedPage] = useState(1);
    const [active, setActive] = useState(false);
    const Pagetitle = selectedPage === 1 ? "Takenoverzicht" : "Template";
    useEffect(() => {
        setActive(false)
    },[selectedPage])
    return (
        <VerticalPageLayout className={`task-screen page-in-animation ${pageSwap && "page-out-animation"}`}>
            <TitleSwitch active={active} setActive={setActive} title={Pagetitle} page1="Taken" page2="Template" selectedPage={selectedPage} setSelectedPage={setSelectedPage} />
            <Pages selectedPage={selectedPage} setSelectedPage={setSelectedPage} />
            <PipeLineModal dismiss={() => setActive(false)} visible={active} />
        </VerticalPageLayout>
    )
}

const PipeLineModal = ({dismiss, visible}) => {
    const cards = [
        { id: 1, title: "Lead opvolgen", description: "Volg een lead op die al een tijdje geen contact meer heeft gehad.", value: 1500, defrence: 500 },
        { id: 2, title: "Nieuwe lead", description: "Voeg een nieuwe lead toe aan het systeem en wijs deze toe aan een collega." },
        { id: 3, title: "Nieuwe lead", description: "Voeg een nieuwe lead toe aan het systeem en wijs deze toe aan een collega." },
        { id: 4, title: "Nieuwe lead", description: "Voeg een nieuwe lead toe aan het systeem en wijs deze toe aan een collega." }
    ];
    // const defrenceStatus = value >= defrence ? "positive" : "negative";
    return (
       <VerticalLayout className={`pipeline ${visible ? "visible" : "not-visible"}`}>
            <HorizontalLayout className="phone-column" style={{ gap: "1rem" }}>
                {cards.map(card => (
                    <StandardComp editClass={"pipeline-card"} key={card.id} title={card.title} description={card.description}>
                        <TitleAtom className={"small-text"}  title={card.title}/>
                        <TitleAtom className={"medium-text"}  title={`Value: ${card.value}`} />
                        <TextAtom className={"small-text"}  />
                    </StandardComp>
                ))}
            </HorizontalLayout>
            <HorizontalLayout className="phone-column" style={{ gap: "1rem", width: "auto" }}>
                <StandardComp editClass={"no-margin pipeline-stats"} style={{ width: "70%" }}>

                </StandardComp>
                <StandardComp editClass={"no-margin pipeline-stats"} style={{ width: "30%" }}>

                </StandardComp>
            </HorizontalLayout>
            
       </VerticalLayout>
    )
}

const Pages = ({selectedPage, setSelectedPage}) => {
    switch(selectedPage){
        case 1: return <TasksPage setSelectedPage={setSelectedPage} />
        case 2: return <TemplatePage />
        default: return <></>
    }
}


const TitleSwitch = ({title, page1, page2, selectedPage, setSelectedPage, active, setActive}) => {
    const buttons = [
        {
            onClick: () => setSelectedPage(1),
            id: 1,
            content: page1,
            selected: selectedPage === 1,
        },
        {
            onClick: () => setSelectedPage(2),
            id: 2,
            content: page2,
            selected: selectedPage === 2,
        }
    ]
    return(
        <HorizontalLayout className="standard-padding" style={{ width: "auto", gap: "1rem" }}>
            <TitleAtom title={title} />
                {/* <IconButton className={`icon-report ${active ? "active" : ""}`} style={{ backgroundColor: active ? "var(--primary-500)" : "var(--white)", border: "2px solid var(--border-color)", padding: ".75rem 1rem", color: active ? "var(--white)" : "var(--primary-500)", borderRadius: "calc(.5rem * var(--br-scale))" }} icon2="project" onClick={() => setActive(!active)} /> */}
            <ButtonGroup buttons={buttons} size={`medium`} />
            
        </HorizontalLayout>
    )
}
